// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"460":"CallupVideoAppHead","570":"CallupHead"}[chunkId] + "." + {"460":"c20c67f094","570":"2de827f6b1"}[chunkId] + ".js";
};